import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  border-radius: 1rem;
  background-color: ${({theme}) => theme["primaryTransparent"]};
`;
